import { useId } from 'react';

export type UseFieldIdReturn = {
  fieldId: string;
  labelId: string;
};

export default function useFieldId(fieldName: string, id?: string): UseFieldIdReturn {
  const uid = useId();

  return id
    ? {
        fieldId: id,
        labelId: `label-${id}`,
      }
    : {
        fieldId: `field-${fieldName}-${uid}`,
        labelId: `label-${fieldName}-${uid}`,
      };
}
